import classes from "./PackageTitle.module.css";

const PackageTitle = ({ title, active }) => {
	return <div className={` font-600 ${active ? classes.text : classes.inactiveText}`}>{title}</div>;
};

export default PackageTitle;
